import { eventStatuses } from "../../../utils/Constants";

export const EVENT_FORM_STEP_IDS = {
  basicInfo: "basic-info",
  crewSize: "crew-size",
  rolesShifts: "roles-shifts",
  zonesRequirements: "zones-requirements",
  publishPay: "publish-pay",
};

/** Company wizard of a draft event: it ends on Publish & Pay, which raises the publishing request. */
export const COMPANY_DRAFT_EVENT_STEP_IDS = [
  EVENT_FORM_STEP_IDS.basicInfo,
  EVENT_FORM_STEP_IDS.crewSize,
  EVENT_FORM_STEP_IDS.rolesShifts,
  EVENT_FORM_STEP_IDS.zonesRequirements,
  EVENT_FORM_STEP_IDS.publishPay,
];

const hasItems = (list) => Array.isArray(list) && list.length > 0;
const hasText = (value) => typeof value === "string" && value.trim() !== "";

/** Whether a saved draft already holds what each wizard step requires. */
const DRAFT_STEP_DONE = {
  // The step's required fields: name, type, city, location, brief and the event dates.
  [EVENT_FORM_STEP_IDS.basicInfo]: (event) =>
    hasText(event?.name) &&
    Boolean(event?.event_type_id ?? event?.event_type?.id ?? event?.event_type) &&
    Boolean(event?.city?.id ?? event?.city_id) &&
    hasText(event?.address) &&
    hasText(event?.description) &&
    Boolean(event?.event_start_at && event?.event_end_at),
  [EVENT_FORM_STEP_IDS.crewSize]: (event) => Boolean(event?.crew_size_plan),
  // Every role needs at least one shift, like the step's validation.
  [EVENT_FORM_STEP_IDS.rolesShifts]: (event) => {
    const roles = event?.event_roles ?? event?.event_roles_attributes;
    return (
      hasItems(roles) &&
      roles.every((role) =>
        hasItems(role?.event_role_shifts ?? role?.event_role_shifts_attributes),
      )
    );
  },
  // The company portal also requires the zone map.
  [EVENT_FORM_STEP_IDS.zonesRequirements]: (event, { requireZoneMap } = {}) =>
    hasItems(event?.zones) && (!requireZoneMap || hasText(event?.zones_image_url)),
};

/** Company wizard of an event that is not a draft: no Crew Size or Publish & Pay steps. */
const COMPANY_EVENT_STEP_IDS = [
  EVENT_FORM_STEP_IDS.basicInfo,
  EVENT_FORM_STEP_IDS.rolesShifts,
  EVENT_FORM_STEP_IDS.zonesRequirements,
];

/** Index of a step in the company edit wizard, which has more steps for a draft. */
export const getCompanyEditStep = (event, stepId) =>
  Math.max(
    0,
    (event?.status === eventStatuses.draft ? COMPANY_DRAFT_EVENT_STEP_IDS : COMPANY_EVENT_STEP_IDS).indexOf(
      stepId,
    ),
  );

/** Whether the saved draft already holds what a step requires; Publish & Pay never is. */
export const isDraftStepDone = (event, stepId, options) =>
  Boolean(DRAFT_STEP_DONE[stepId]?.(event, options));
